<div class="content" [ngClass]="{'filter-wrapper--toogle':configParam.filter.toggleFilter}">
  <div class="board-wrapper">
    <div class="board__main-content">
      <div class="board-header">
        <div class="board-header__row">
          <div class="board-header__quick-search">
            <q-quicksearch *ngIf="configParam.quickSearch.show" [data]="configParam.quickSearch.data" [(FilterBadge)]="filterBadges" (result)="quickSearch($event)"></q-quicksearch>
          </div>
          <div class="board-header__btns">
            <div class="display-mode">
              <i class="fas fa-columns q-c-main m-1"></i>

              <div class="checkbox checbox-switch switch-primary d-inline">
                <label>
                  <input type="checkbox" (click)="changeDisplayMode()" [checked]="configParam.displayMode == PipeDisplayMode.Grid">
                  <span></span>
                </label>
              </div>
              <i class="fas fa-list-alt q-c-main"></i>
            </div>

            <button class="btn-no-background" title="Gestion des colonnes" (click)="openSettingCol()"><i class="fas fa-columns"></i><i class="fas fa-cog btn-no-background__cog"></i></button>

            <ng-container [ngTemplateOutlet]='btnTemplate'></ng-container>

            <button *ngIf="configParam.filter.show" (click)="configParam.filter.toggleFilter = !configParam.filter.toggleFilter" class="btn-no-background"><i class="fas fa-filter q-c-main"></i></button>

          </div>
        </div>
        <div class="board-header__row">
          <q-badge-filter *ngIf="configParam.filter.show" [(FilterBadge)]="filterBadges" (FilterBadgeChange)="onFilterChange($event)" class="w-100 mt-1"></q-badge-filter>
        </div>
      </div>
      <div class="board-body">
        <div class="board" *ngIf="configParam.displayMode == PipeDisplayMode.Pipe; else boardGrid" (mousemove)="dndService.onMouseMoveWrapper($event)">
          <div *ngFor="let col of pipeColumns; let colId = index" id="{{colId}}" class="list-wrapper">
            <div class="list">
              <div class="list-header">

                <div *ngIf="!col.isEditMode" (click)="col.isEditMode = true" class="list-header__title">
                  {{col.titre}}    <ng-container *ngTemplateOutlet='columnHeaderTemplate;context:{col:col,colId:colId}'></ng-container>
                </div>
                <div *ngIf="col.isEditMode" class="list-header__title--edit">
                  <input *ngIf="col.isEditMode" class="form-control" [(ngModel)]="col.titre" />
                  <div class="q-pointer px-2">
                    <i class="fas fa-save q-c-main" (click)="changeColumnName(col)"></i>
                  </div>
                </div>

              </div>
              <div class="list-cards" [ngClass]="{'list-cards--mockup':configParam.pipe.cardMockup}"
                   (mousemove)="dndService.onMouseMoveColumn($event,colId)"
                   (mouseenter)="dndService.onMouseEnterColumn($event,colId)"
                   (mouseleave)="dndService.onMouseLeaveColumn($event,colId)">
                <div class="list-cards--over">
                  <i class="fas fa-plus-circle"></i>
                </div>
                <cdk-virtual-scroll-viewport itemSize="150" class="h-100 vs-pipe" [attr.data-columns]="colId" *ngIf="!configParam.pipe.cardMockup; else mockupCard" #ScrollViewport>
                  <ng-container *cdkVirtualFor="let cardInfo of col.cards; let cardId = index">
                    <a class="list-card"
                       (mousedown)="dndService.onMouseDownCard($event,colId,cardId)"
                       (mouseup)="dndService.onMouseUpCard($event)">
                      <ng-container *ngTemplateOutlet='cardTemplate; context:{ $implicit: cardInfo }'></ng-container>
                    </a>
                  </ng-container>
                </cdk-virtual-scroll-viewport>
              </div>
              <div class="list-footer">
                <ng-container *ngTemplateOutlet='footerTemplate;context:{col:col,colId:colId}'></ng-container>
              </div>
            </div>
          </div>


          <div *ngIf="pipeColumns?.length > 0" class="list-wrapper">
            <div class="list" [ngClass]="{'list--medium':newColToggle,'list--small':!newColToggle}">
              <div class="list-header">
                <div class="column-header-title -center  q-pointer" (click)="toggleNewCol(true)"><i class="fas fa-plus-circle mr-3 q-c-main"></i> Ajouter une colonne</div>
              </div>
              <div class="list-cards">
                <input class="form-control q-input-required q-main-focus q-input-column input-col" [(ngModel)]="newColName" placeholder="nom de la colonne" />
                <i class="fas fa-save q-c-main q-pointer mr-2" (click)="createNewCol(col)"></i>
                <i class="fas fa-times q-c-danger q-pointer mr-2" (click)="toggleNewCol(false)"></i>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>

  <div class="filter-wrapper" *ngIf="configParam.filter.show">
    <div class="filter-wrapper__body">
      <button (click)="configParam.filter.toggleFilter = !configParam.filter.toggleFilter" class="q-btn icon "><i class="fas fa-times"></i></button>
      <q-filter class="h-100" [option]="filterOption" [(badge)]="filterBadges" [model]="configParam.filter.modelCode" [modelGroupe]="configParam.filter.modelGroup" (badgeChange)="onFilterChange($event)" (SendEvent)="filterBtnClick($event)"></q-filter>
    </div>
  </div>
</div>

<ng-template #boardGrid>
  <q-customgrid *ngIf="gridLoaded; else gridLoading" [customgridName]="configParam.gridModel" [completeWhere]="gridWhere" [updateValue]="gridUpdateValue" (gridReady)="gridReady($event)"></q-customgrid>
  <ng-template #gridLoading>
    <div class="loading  q-c-main">
      <div class="message">Chargement des données</div>
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </ng-template>
</ng-template>

<ng-template #modalSettingColumn let-modal>
  <div class="modal-header">
    <h5 class="q-c-main q-bold">Gestion des colonnes</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-3 border-model-col">
        <div *ngFor="let model of columnModelList" class="ellipsis" title="{{model.Info}}" (click)="selectColumnModel(model)" [ngClass]="{'model-selected':currentColumnModel.Code == model.Code}">
          {{model.Info ? model.Info : 'sans titre'}}
        </div>
        <div (click)="selectColumnModel(null)" class="ellipsis" [ngClass]="{'model-selected':!currentColumnModel.Code}">Nouveau modèle</div>
      </div>
      <div class="col-9">
        <div class="row mb-2">
          <div class="col-12"> <input type="text" class="form-control q-main-focus  w-100 " [(ngModel)]="currentColumnModel.Info" /></div>
        </div>
        <div class="row mb-2 list-col">
          <div class="col-12 " *ngFor="let col of columnList">
            <div class="q-check" (click)="checkColumnModel(col.Value)">
              <input type="checkbox" [checked]="selectedColumn.includes(col.Value)" />
              <label class="my-0">
                <span></span>{{col.Text}}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-8"><button class="q-btn q-main m-0 w-100" (click)="saveColumnModel()">Enregistrer</button></div>
          <div class="col-2"><button *ngIf="currentColumnModel.Code" class="q-btn m-0 q-danger q-c-main w-100" (click)="deleteColumnModel()"><i class="fas fa-trash-alt"></i></button></div>
          <div class="col-2"><button *ngIf="currentColumnModel.Code" class="q-btn m-0 q-secondary q-c-main w-100" (click)="addToClipboard()"><i class="far fa-copy"></i></button></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!--Mockup card-->
<ng-template #mockupCard>
  <a class="list-card" *ngFor="let x of [].constructor(3)">
    <ng-container *ngTemplateOutlet='cardTemplate'></ng-container>
  </a>
</ng-template>

<ng-container *ngTemplateOutlet='modalTemplate'></ng-container>





<!--#region Formation-->
<!--#region BOUTON-->
<ng-template #btnFormation>
  <button class="btn-new-stage" title="Creation d'un stage" (click)="openModalCreateStage($event ,null)"><i class="fas fa-plus-square"></i></button>
</ng-template>
<!--#endregion-->
<!--#region CARTE-->
<ng-template #cardFormation let-cardInfo>
  <queoval-stage-pipe-card [card]="cardInfo"></queoval-stage-pipe-card>
</ng-template>
<!--#endregion-->
<!--#region FOOTER-->
<ng-template #footerFormation let-col="col" let-colId="colId">
  <div class="column-footer-picto" (click)="openModalCreateStage($event ,col)"> <i class="fas fa-plus-circle"></i>  </div>
  <div class="column-footer-txt" (click)="openModalCreateStage($event, col)">Créer un stage</div>
</ng-template>
<!--#endregion-->
<!--#region MODAL-->
<ng-template #modalFormation>
  <!--Creation stage-->
  <q-comp-stage-pipe-stage-creation [colType]="colType" (onModalClose)="openStage($event,PipeDisplayMode.Pipe)"></q-comp-stage-pipe-stage-creation>
  <!-- Creation cursus-->
  <q-comp-cursus-creation (onModalClose)="buildFilter()"></q-comp-cursus-creation>
  <!--Validation de la suppression du cursus -->
  <q-comp-cursus-delete (onModalClose)="closeDeleteCursus($event)"></q-comp-cursus-delete>
  <!--Duplication cursus -->
  <q-comp-cursus-duplicate (onModalClose)="closeDuplicateCursus()"></q-comp-cursus-duplicate>
  <!--Edition cursus-->
  <q-comp-cursus-edit (onModalClose)="buildFilter()"></q-comp-cursus-edit>
</ng-template>
<!--#endregion-->
<!--#endregion-->
<!--#region Action Co-->
<!--#region BOUTON-->
<ng-template #btnActionCo>
  <button title="Pondération" class="btn-no-background" (click)="isPonderation = !isPonderation" [ngClass]="{'btn-no-background--toggle':isPonderation}">
    <i class="fas fa-balance-scale"></i>
  </button>

  <button class="btn-no-background" title="Création d'une nouvelle action commerciale" (click)="openPopUp($event, null)">
    <i class="fas fa-plus-square"></i>
    <div #popUpCreationActionCo id="popUp-1" class="column-btn-popup">
      <ng-container *ngFor="let mode of lstModes">
        <div class="column-footer-popup-card" (click)="openCreateActionCo(mode.id,null)">
          <div class="column-footer-popup-card-picto "><i class="fas fa-plus"></i></div>
          <div class="column-footer-popup-card-txt">{{mode.value}}</div>
        </div>
      </ng-container>
    </div>
  </button>
</ng-template>
<!--#endregion-->
<!--#region HEADER COLUMN-->
<ng-template #columnHeaderActionCo let-col="col" let-colId="colId">
  <div *ngIf="!isPonderation; else prixPonderation" class="q-badge">{{col.infoSupp?.Montant|money}}</div>
  <ng-template #prixPonderation><div class="q-badge"> {{col.infoSupp?.MontantPondere|money}}</div></ng-template>
</ng-template>
<!--#endregion-->
<!--#region CARTE-->
<ng-template #cardActionCo let-cardInfo>
  <queoval-action-co-pipe-card [card]="cardInfo" [isPonderation]="isPonderation"></queoval-action-co-pipe-card>
</ng-template>

<!--<ng-template #modalActionCO let-modal>
  <div class="modal-body modal-xxl">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="container-modal p-0">
      <q-action-co-card *ngIf="showActionCo" [idActionCo]="idActionCo" [OpenView]="action" modalContainer [Type_EVE]="type" [TypeDevis]="mode" [idClient]="idClient" (actionCoCreated)="PushNewCard($event.Card, $event.Type)"></q-action-co-card>
    </div>
  </div>
</ng-template>-->
<!--#endregion-->
<!--#region FOOTER-->
<ng-template #footerActionCo let-col="col" let-colId="colId">
  <div class="column-footer-picto" (click)="openPopUp($event ,col,colId)"> <i class="fas fa-plus-circle"></i>  </div>
  <div class="column-footer-txt" (click)="openPopUp($event, col,colId)">Créer une nouvelle action</div>
  <div #popUpCreationActionCo id="popUp{{colId}}" class="column-footer-popup">
    <ng-container *ngFor="let mode of lstModes">
      <div class="column-footer-popup-card" (click)="openCreateActionCo(mode.id,col)">
        <div class="column-footer-popup-card-picto "><i class="fas fa-plus"></i></div>
        <div class="column-footer-popup-card-txt">{{mode.value}}</div>
      </div>
    </ng-container>
  </div>
</ng-template>
<!--#endregion-->
<!--#endregion-->
<!--#region Catalogue-->
<!--#region CARTE-->
<ng-template #cardCatalogue let-cardInfo>
  <queoval-pipe-catalogue-card [card]="cardInfo"></queoval-pipe-catalogue-card>
</ng-template>
<!--#endregion-->
<!--#region FOOTER-->
<ng-template #footerCatalogue let-col="col" let-colId="colId">
  <div class="column-footer-picto" (click)="createFormation($event ,col,colId)"> <i class="fas fa-plus-circle"></i>  </div>
  <div class="column-footer-txt" (click)="createFormation($event, col,colId)">Nouveau produit</div>
</ng-template>
<!--#endregion-->
<!--#region BOUTON-->
<ng-template #btnCatalogue>
  <button *ngIf="formationDefaultExist" class="btn-no-background" title="Personnaliser le mode sur mesure" (click)="openCatalogue(formationDefaultExist)"><i class="fas fa-gears q-c-main q-pointer"></i></button>
</ng-template>
<!--#endregion-->
<!--#endregion-->
<!--#region Obligation-->
<!--#region CARTE-->
<ng-template #cardObligation let-cardInfo>
  <queoval-pipe-obligation-card [card]="cardInfo"></queoval-pipe-obligation-card>
</ng-template>
<!--#endregion-->
<!--#endregion-->
